import React, { useState, useEffect, useCallback } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import BrandCard from "./brandCard";

const AddBrands = (props) => {
  const [inputValues, setBrandName] = useState({
    brandName: "",
    editBrandName: "",
    desc:""
  }); 

  const [isNameAffected,setBrandNameAffected] = useState(false);
  const [brands, setBrands] = useState(null);
 
  const [oldBrand, setOldBrand] = useState({});
  const [brandImage, setBrandImage] = useState(null)
  useEffect(() => {
    props.onFetchBrands();
    setBrands(props.brands);
  }, []);

  const handleChange = useCallback((event) => {
    
    const { name, value } = event.target;
    setBrandName({ ...inputValues, [name]: value });
    
  });
 
  const handleSubmit = (e) => {
    e.preventDefault();
    let brandName = inputValues.brandName;
    let brandArray = props.brands;
    if(!brandImage){
      return alert("Please Upload the Brand Image")
    }
    let brand = {
      name: brandName,
      brandImage:brandImage,
      desc:inputValues.desc
    };
    props.onPostBrands(null, brandArray, brand);
  };

  const handleBrandEdit = (e, brandId, oldName) => {
    const { name, value } = e.target;

    if(name=="editBrandName"&&!isNameAffected){
      setBrandNameAffected(true)
    }
    // console.log(brandId,oldName)
    setBrandName({ ...inputValues, [name]: value });
    setOldBrand({ brandId: brandId, brandName: oldName });
  };

  const handleEditSubmit = (e, id) => {
    e.preventDefault();
    let editedBrand = inputValues.editBrandName;
    let brandArray = props.brands;
    let brand = {
      id: id,
      name: editedBrand, 
      brandImage:brandImage,
      desc:inputValues.desc,
    };
    let oldBrandObj = oldBrand;
    props.onEditBrand(oldBrandObj, brandArray, brand, isNameAffected);
  }; 

  const handleDeleteBrand = (e, brand) => {
    e.preventDefault();
    props.onDeleteBrand(brand);
  }; 
 
  let diffBrands = props.brands;
  let brandTypes = 
    diffBrands &&
    diffBrands.map((brandTypes, index) => (
      
      <BrandCard
        key={index} 
        id={brandTypes.id}
        brandName={brandTypes.name}
        imgUrl={brandTypes.imgUrl} 
        desc={inputValues.desc}
        editBrandName={inputValues.editBrandName}
        handleChange={handleBrandEdit}
        setBrandImage={setBrandImage}
        setBrand={()=>setBrandName({...inputValues,desc:brandTypes.desc,editBrandName: brandTypes.name })}
        handleEditSubmit={handleEditSubmit}
        handleDeleteBrand={handleDeleteBrand}
        brandBtnLoading={props.brandBtnLoading}
        deleteBtnLoading={props.deleteBtnLoading} 
      />
    ));

  if (props.loading) {
    return <Spinner />;
  }

  return (
    <div className="container mt-2">
      <h3 className="text-center">Brands Management</h3>
      <form>
        <div className="row">
          <div className="col-md-3 m-1">
            <input
              name="brandName"
              type="text"
              className="form-control"
              placeholder="Enter Brand Name"
              onChange={handleChange}
              value={inputValues.brandName}
            />
            
          </div>
          <div className="col-md-3 m-1">
                <input
                  name="brandImage"
                  type="file" 
                  className="form-control "
                  placeholder="Upload Brand Image"
                  accept="image/*"
                  onChange={(e)=>
                   setBrandImage( e.target.files[0])
                  }
                />
            </div>

            <div class="form-group col-md-4">
              {/* <label for="Description">Description</label> */}
                <textarea
                  name="desc"
                  type="text"
                  id="Description"
                  className="form-control"
                  placeholder="Description"
                  onChange={handleChange}
                  value={inputValues.desc}
                  rows="3"
                  required
                />
             </div>

           
              <div className="col m-1">
                <button
                  type="submit"
                  className="btn btn-info "
                  onClick={handleSubmit}
                  disabled={props.brandBtnLoading}
                >
                  {props.brandBtnLoading ? "Adding" : "Add"}
                </button>
              </div>
        </div>
      </form>
      <hr />
      <div className="row mt-2">{brandTypes}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    brands: state.brands.brands,
    loading: state.brands.loading,
    brandBtnLoading: state.brands.brandBtnLoading,
    deleteBtnLoading: state.brands.deleteBtnLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPostBrands: (oldBrand, brandArray, brand) =>
      dispatch(actions.onPostBrands(oldBrand, brandArray, brand)),
      onEditBrand:(oldBrand,brandArray,brand,isNameAffected)=>dispatch(actions.onEditBrand(oldBrand,brandArray,brand,isNameAffected)),
    onFetchBrands: () => dispatch(actions.onFetchBrands()),
    onDeleteBrand: (brandId) => dispatch(actions.onDeleteBrand(brandId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddBrands, Axios));
